'use client';

import { useQueryWithUserId, useRegionStore } from '@northladder/services';

import { USER_REGISTRATION_API } from '../userRegistrationAPIClient';

/**
 * This is to track the device categories from the backend.
 */
const DEVICE_CATEGORIES_KEY = 'public-device-categories-key';

/**
 * This hook fetches a list of device category id and name which are eligible
 * for trade-in. This should be used in case where authenticated user context
 * is not available.
 */
export const usePublicCategoriesListQuery = () => {
  const { tenantId } = useRegionStore()?.tenantConfig || {};

  const { data, isError, error, isPending, refetch } = useQueryWithUserId({
    queryKey: [DEVICE_CATEGORIES_KEY, tenantId],
    networkMode: 'always',
    queryFn: () =>
      USER_REGISTRATION_API.fetchPublicTradeInDeviceCategories(tenantId),
  });

  return {
    data,
    error,
    isError,
    isPending,
    refetch,
  };
};
